// extracted by mini-css-extract-plugin
export default {"error":"NotFound_error__T4ccW","title":"NotFound_title__dQAtB","subTitle":"NotFound_subTitle__UdXyH"};